import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Ahora organizo todo el año sin estrés. Es increíble el tiempo que ahorro.',
    author: 'Natalia G.',
    location: 'Córdoba'
  }, {
    text: 'Mis estudiantes participan más y entienden mejor las corrientes psicológicas.',
    author: 'Martín R.',
    location: 'Buenos Aires'
  }, {
    text: 'Las clases cambiaron por completo. Todo está más claro y estructurado.',
    author: 'Laura P.',
    location: 'Mendoza'
  }, {
    text: 'Antes tardaba horas buscando material. Ahora tengo todo listo y mis alumnos lo notan.',
    author: 'Cecilia M.',
    location: 'Rosario'
  }, {
    text: 'El banco de dinámicas es oro puro. Mis clases pasaron de ser teóricas a súper participativas.',
    author: 'Diego F.',
    location: 'Tucumán'
  }, {
    text: 'La planificación anual me salvó. La presenté tal cual y mi directora quedó encantada.',
    author: 'Valeria S.',
    location: 'La Plata'
  }, {
    text: 'Llevo 15 años dando Psicología y nunca tuve un recurso tan completo. Lo recomiendo a todos mis colegas.',
    author: 'Roberto A.',
    location: 'Salta'
  }, {
    text: 'Las rúbricas y evaluaciones son clarísimas. Mis estudiantes saben exactamente qué se espera de ellos.',
    author: 'Florencia T.',
    location: 'Mar del Plata'
  }];
  return <section className="bg-gray-50 py-4 px-4" data-id="element-241">
      <div className="max-w-6xl mx-auto" data-id="element-242">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-3" data-id="element-243">
          Testimonios de Docentes en Argentina
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-244">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-245">
              <div className="flex gap-1 mb-1" data-id="element-246">
                {[...Array(5)].map((_, starI) => <Star key={starI} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-247" />)}
              </div>
              <p className="text-gray-700 italic mb-2 flex-grow" data-id="element-248">"{t.text}"</p>
              <div className="mt-auto border-t pt-2" data-id="element-249">
                <p className="font-bold text-gray-900" data-id="element-250">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-251">{t.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}